module.exports = __webpack_public_path__ + "static/media/selected_marina_marker.406c347c.svg";